import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import configuration from 'portaltransparencia-common/config/Config.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import { connect } from 'react-redux';
import * as actions from './Actions.js';

class MovimentacaoEntrada extends Component {
  static propTypes = {
    movimentacoes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    addErrorNotification: PropTypes.func.isRequired
  };

  renderMovimentacoesEntrada = movimentacoes => {
    return movimentacoes
      .filter(movimentacao => movimentacao.get('tipo') == 'ENTRADA')
      .map(entrada => {
        return (
          <tr ref="row" key={entrada.get('numero')}>
            <td>{entrada.get('fornecedorDescricao')}</td>
            <td>{DateUtils.formatDateTimeShort(entrada.get('data'))}</td>
            <td>{entrada.get('numero')}</td>
            <td>{entrada.get('numeroNota')}</td>
            <td>{entrada.get('quantidade')}</td>
            <td>{entrada.get('unidade')}</td>
            <td className="right">
              <NumberFormatter value={entrada.get('valorUnitario')} />
            </td>
            <td className="right">
              <NumberFormatter value={entrada.get('valorTotal')} />
            </td>
          </tr>
        );
      });
  };

  onExporta = (exportType, openTab, windowParams) => {
    const { apiURL } = configuration;
    const { params, movimentacoes, addErrorNotification } = this.props;
    const { entidade, exercicio } = StorageService.getItem('userInfo');

    if (!movimentacoes.isEmpty()) {
      const movimentacaoItem = `entidade=${entidade.id}&exercicio=${exercicio.id}&centroCusto=${params.centrocusto}&item=${params.item}`;

      window.open(
        `${apiURL}/api/movimentacao/report?${movimentacaoItem}&tipo=ENTRADA&exportType=${exportType}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  render() {
    const { movimentacoes } = this.props;

    if (movimentacoes.isEmpty()) {
      return null;
    }

    return (
      <Panel title="Entradas" isTable tableResponsive expansible={false}>
        <Row>
          <Col xs={6} />
          <Col xs={6}>
            <ExportButtonGroup onClick={this.onExporta} visible={true} />
          </Col>
        </Row>

        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader empty={movimentacoes.isEmpty()}>
              <tr>
                <th>Fornecedor</th>
                <th>Data</th>
                <th>Número</th>
                <th>Número Nota</th>
                <th>Quantidade</th>
                <th>Unidade</th>
                <th className="right">Valor Unitário</th>
                <th className="right">Valor Total</th>
              </tr>
            </TableHeader>
            <tbody>{this.renderMovimentacoesEntrada(movimentacoes)}</tbody>
          </table>
        </div>
      </Panel>
    );
  }
}

function mapStateToProps(state) {}

const allActions = {
  ...actions,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(MovimentacaoEntrada);
